import { render, staticRenderFns } from "./StammMaske.vue?vue&type=template&id=77c9479d&scoped=true"
import script from "./StammMaske.vue?vue&type=script&lang=ts"
export * from "./StammMaske.vue?vue&type=script&lang=ts"
import style0 from "./StammMaske.vue?vue&type=style&index=0&id=77c9479d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9479d",
  null
  
)

export default component.exports